import React from 'react';

const NationalOperationsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_NATIONAL_OPERATION',
    'ROLE_NATIONAL_OPERATION_LIST',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/national/operations',
      exact: true,
      component: React.lazy(() =>
        import('./national_operations_list/NationalOperations')
      )
    }
  ]
};

const NationalOperationsManagerConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_OPERATIONMANAGER',
    'ROLE_OPERATIONMANAGER_LIST',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/national/operation/participate',
      component: React.lazy(() =>
        import(
          './national_operations_participate/NationalOperationsParticipate'
        )
      )
    }
  ]
};

const NationalOperationAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_NATIONAL_OPERATION',
    'ROLE_NATIONAL_OPERATION_ADD',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/national/operation/add',
      component: React.lazy(() =>
        import('./national_operation_edit/NationalOperationEdit')
      )
    }
  ]
};

const NationalOperationEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_NATIONAL_OPERATION',
    'ROLE_NATIONAL_OPERATION_EDIT',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/national/operation/:id',
      component: React.lazy(() =>
        import('./national_operation_edit/NationalOperationEdit')
      )
    }
  ]
};

export {
  NationalOperationsConfig,
  NationalOperationsManagerConfig,
  NationalOperationAddConfig,
  NationalOperationEditConfig
};
